import { renderApiDomain } from "../helper/renderApiDomain";
import { get } from "../helper/request";

// /countries/registration-open
export const getCountries = () => {
  return get(renderApiDomain() + "countries/registration-open");
};
